class WedlukVisibility {
    static get RequestSent() {
        return { id: 1, Status: "Request sent" };
    }

    static get Accepted() {
        return { id: 2, Status: "Accepted" };
    }

    static get Rejected() {
        return { id: 3, Status: "Rejected" };
    }

    static get Types() {
        return [
            WedlukVisibility.RequestSent,
            WedlukVisibility.Accepted,
            WedlukVisibility.Rejected,

        ];
    }
}

module.exports = WedlukVisibility;
